<script>
	import Icon from '$lib/components/Icon.svelte'

	export const expanded = null
	export let border = 'border-b'
	export const expand = null
	//export let basis = 'basis-[calc(50%-40px)]'
</script>

<details
	class="faqwrap relative block {border} basis-[calc(50%-30px)]"
	itemscope
	itemtype="https://schema.org/Question"
>
	<summary class="h4 flex items-center justify-between pb-2 pt-2">
		<h4 class="unstyled pr-4 pt-2 text-xl" itemprop="name">
			<slot name="question" />
		</h4>
		<Icon
			src="/images/icons/gray/arrow_square.svg"
			cls="transition-all cursor-pointer rotateme"
			width="w-10"
			height="h-10"
		/>
	</summary>
	<div itemprop="answerCount" content="1" />
	<div class="mb-6" itemscope itemtype="https://schema.org/Answer" itemprop="acceptedAnswer">
		<div itemprop="text"><slot name="answer" /></div>
	</div>
</details>

<style lang="scss">
	.faqwrap[open] :global(.rotateme) {
		transform: rotate(180deg);
	}
	.faqwrap :global(p),
	.faqwrap :global(ul),
	.faqwrap :global(ol) {
		font-size: 1rem;
		line-height: 1.75;
		margin-bottom: 1em;
	}

	.faqwrap :global(ul) {
		list-style-type: disc;
		padding-left: 1.5rem;
	}
	.faqwrap :global(ol) {
		list-style-type: decimal;
		padding-left: 1.5rem;
	}

	.faqwrap :global(a) {
		@apply text-primary-500;
	}

	.faqwrap summary::-webkit-details-marker {
		display: none;
	}
</style>
